import React from "react";
import classNames from "classnames";

import { MultiOffers } from "@data-types/bet-booster/MultiOffers";

export default function BetBuilderPicksOfferDisplay(props: {
	offer: MultiOffers;
	isLast: boolean;
	isPopup?: boolean;
	isWrapped?: boolean;
}) {
	if (props.isLast) {
		return (
			<div
				className={classNames(
					"card--qp__item card--bbp__item is-last",
					{
						"card--bbp--nowrap__item": !props.isPopup,
						"card--play__item--full": props.isPopup,
					}
				)}
			>
				<div className="card--qp__track card--bbp__track">
					<div className="card--qp__dot is-last" />
				</div>
				<div
					className={classNames(
						"card--qp__market card--bbp__market is-last",
						{
							"card--qp--nowrap__market card--bbp--nowrap__market":
								!props.isWrapped,
						}
					)}
				>
					<span
						className={classNames(
							"card--qp__type card--bbp__type",
							{
								"card--qp--nowrap__type card--bbp--nowrap__type":
									!props.isWrapped,
							}
						)}
					>
						{props.offer.formattedBettingType}:
					</span>
					<span
						className={classNames("card--qp__tip card--bbp__tip", {
							"card--qp--nowrap__tip card--bbp--nowrap__tip":
								!props.isWrapped,
						})}
					>
						{props.offer.formattedBettingTypeTip}
					</span>
				</div>
			</div>
		);
	}

	return (
		<div
			className={classNames("card--qp__item card--bbp__item", {
				"card--bbp--nowrap__item": !props.isPopup,
				"card--play__item--full": props.isPopup,
			})}
		>
			<div className="card--qp__track card--bbp__track">
				<div className="card--qp__dot" />
				<div className="card--qp__line" />
			</div>
			<div
				className={classNames("card--qp__market card--bbp__market", {
					"card--qp--nowrap__market card--bbp--nowrap__market":
						!props.isWrapped,
				})}
			>
				<span
					className={classNames("card--qp__type card--bbp__type", {
						"card--qp--nowrap__type card--bbp--nowrap__type":
							!props.isWrapped,
					})}
				>
					{props.offer.formattedBettingType}:
				</span>
				<span
					className={classNames("card--qp__tip card--bbp__tip", {
						"card--qp--nowrap__tip card--bbp--nowrap__tip":
							!props.isWrapped,
					})}
				>
					{props.offer.formattedBettingTypeTip}
				</span>
			</div>
		</div>
	);
}
